module.exports = __webpack_public_path__ + "img/sun_white.374a5f8b.svg";